import { MinimalDropdownSkin } from "./minimal-dropdown-skin";
import { StandardDropdownSkin } from "./standard-dropdown-skin";
import { WideDropdownSkin } from "./wide-dropdown-skin";
export const getDropdownComponentBySkin = (skin) => {
    switch (skin) {
        case "wide":
            return WideDropdownSkin;
        case "minimal":
            return MinimalDropdownSkin;
        case "standard":
        default:
            return StandardDropdownSkin;
    }
};
//# sourceMappingURL=index.js.map